import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Trending from './components/Trending';
import LiveReports from './components/LiveReports';
import Feed from './components/Feed';
import DeepDive from './components/DeepDive';
import Faq from './components/Faq';
import About from './components/About';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-none transition-all hover:bg-primary-600 ${show ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <LiveReports />
        <Feed />
        <DeepDive />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}